/**
 * @file pageType
 * @author fuqiang15
 */

export default {
    computed: {
        isCreate() {
            return this.store.pageType === 'create';
        },
        isDetail() {
            return this.store.pageType === 'detail';
        },
        isEdit() {
            return this.store.pageType === 'edit';
        }
    }
};
